import { Calendar } from "primereact/calendar";
import React from "react";
import { formatDateInputValue, parseDateInputValue } from "./dateValueUtils";

interface NurseDateFieldProps {
    value?: string | null;
    onChange: (value: string) => void;
    placeholder?: string;
    className?: string;
    style?: React.CSSProperties;
    inputStyle?: React.CSSProperties;
    invalid?: boolean;
}

const NurseDateField: React.FC<NurseDateFieldProps> = ({
    value,
    onChange,
    placeholder,
    className,
    style,
    inputStyle,
    invalid = false,
}) => (
    <Calendar
        value={parseDateInputValue(value)}
        onChange={(e) => onChange(formatDateInputValue((e.value as Date | null) ?? null))}
        dateFormat="mm/dd/yy"
        showIcon
        placeholder={placeholder}
        className={className}
        style={style}
        inputStyle={inputStyle}
        inputClassName={invalid ? "p-invalid" : undefined}
    />
);

export default NurseDateField;
